import React from 'react';
import './Home.css';
import Timer from './Timer';
import SpaceButton from './SpaceButton';

export const Home = () => {
  // Updated target date to 17th January. Assumed year 2026 based on current date.
  const targetDate = '2026-01-17T10:00:00';

  return (
    <div className="home-container">
      <section className="main">
       
        <div className="heading">
          <h1>MACHINE LEARNING</h1>
          <h1>WORKSHOP</h1>
          <p>
            AI/ML enables the creation of intelligent chatbots that 
            facilitate natural conversations and structured responses.
          </p>
        </div>
      </section>
      
      {/* SpaceButton */}

      <section className="button-section">
        <a href='https://docs.google.com/forms/d/e/1FAIpQLSe9vYAwFeds19fkRzGZAFSM8Liukl06MPj0_l3CrgJaMd2Rkg/viewform' target="_blank" without rel="noreferrer">
        <SpaceButton />
        </a>
      </section>
      
      {/* Countdown Timer */}
      <section className='count'>
         <div>
          <h1>Gear Up for Learning! Workshop Starts In…</h1>
          <Timer date={targetDate} />
        </div>
      </section>
    </div>
  );
};
